import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import RedirectLinkDetail from './RedirectLinkDetail';
import * as redirectLinkActions from './../../../../../actions/redirectLinkAction';

const mapStateToProps = state => {
    return {
        redirectLinkState: state.redirectLinkReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getRedirectLinkDetail: (id) => dispatch(redirectLinkActions.getRedirectLinkDetail(id)),
        setRedirectLinkDetail: (redirectLink) => dispatch(redirectLinkActions.setRedirectLinkDetail(redirectLink)),
        updateRedirectLinkDetail: (redirectLink) => dispatch(redirectLinkActions.updateRedirectLinkDetail(redirectLink)),
        createRedirectLinkDetail: (redirectLink) => dispatch(redirectLinkActions.createRedirectLinkDetail(redirectLink))
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(RedirectLinkDetail));
